"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoonfireAbilityHandler = exports.MoonfireActorAbilityFactory = exports.MoonfireAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class MoonfireAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Moonfire;
        this.__typeName = "Moonfire";
    }
}
exports.MoonfireAbilityArgs = MoonfireAbilityArgs;
let MoonfireActorAbilityFactory = class MoonfireActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Moonfire", "OneEnemies", 2);
    }
};
MoonfireActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Moonfire")
], MoonfireActorAbilityFactory);
exports.MoonfireActorAbilityFactory = MoonfireActorAbilityFactory;
let MoonfireAbilityHandler = class MoonfireAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        let applyTo = ability.args.target.actorIds;
        if (container.hasAttribute(ability.invokerId, "Charm_Druid_0")) {
            applyTo = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        }
        sequence.push(core_1.CameraVfxStepArgs.Alpha(.3));
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targets: applyTo.map(targetId => ({
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Nature", 70)
                ]
            })),
            onHitOrMiss(sequence, { targetId }, { hit }) {
                sequence
                    .pushSequence("sequential")
                    .push(new core_1.InstantVfxStepArgs(hit ? new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet") :
                    LocationSelector_1.ActorVfxLocationSelector.Miss(targetId), "MoonfireBeam", true));
            },
            onCompleted: sequence => sequence.push(core_1.CameraVfxStepArgs.AlphaReset())
        });
    }
};
MoonfireAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Moonfire)
], MoonfireAbilityHandler);
exports.MoonfireAbilityHandler = MoonfireAbilityHandler;
